import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id C47B2AE6-FB1F-4E54-A951-AD26609ECB80
 * name music-note-off-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-off-outline.svg
 * tags
 * - Music 
 */
export const MusicNoteOffOutlineIcon = createSvgIcon(<><path d="M14 7H18V3H12V7.61L14 9.61M12 10.44L4.41 2.86L3 4.27L12 13.27V13.55A3.94 3.94 0 0 0 8.67 13.23A4 4 0 0 0 10.65 20.95A4.1 4.1 0 0 0 14 16.85V15.27L19.73 21L21.14 19.59M10 19A2 2 0 1 1 12 17A2 2 0 0 1 10 19Z" /></>, 'MusicNoteOffOutlineIcon');
export default MusicNoteOffOutlineIcon